import React, { useEffect } from "react";
import { CssBaseline, Box } from "@mui/material";
import Newsidebar from "../components/shared/newsidebar";
import "../components/home/home.style.css";
import Newheader from "../components/shared/newheader";
import MetaDecorator from "../services/meta_decorator";
import { bodyBg2, fullHeight } from "../style2";

function Profilecard() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Box sx={{...fullHeight, ...bodyBg2}}>
      <CssBaseline />
      <MetaDecorator
        title={"EnrichMyCare - Profilecard"}
        description={"Professional dashboard app"}
      />
      <Newsidebar selected={"profilecard"} />
      <Newheader show_profile_button={true} />
    </Box>
  );
}

export default Profilecard;
